import { createFileRoute } from '@tanstack/react-router';

import { PortalDashboard } from '@/features/portal/portal-dashboard';

export const Route = createFileRoute('/portal/dashboard')({
  component: PortalDashboard,
});
